import { useQueryClient } from '@tanstack/react-query';
import { baseQueryKeys, useGenericCrudApi } from '@cksoftware/react-base';

export const useListApi = <T,>(ModelName: string, controllerName: string, onSaveSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const SaveSuccess = async () => {
    await queryClient.refetchQueries({
      queryKey: [...baseQueryKeys.genericCrudList(controllerName)]
    });
    if (onSaveSuccess) {
      onSaveSuccess();
    }
  };

  const api = useGenericCrudApi<T>(controllerName, ModelName, SaveSuccess);

  return {
    read: api.read,
    list: api.list,
    create: api.createEntity,
    update: api.updateEntity,
    delete: api.deleteEntity
  };
};
